import { mapKeys, camelCase } from 'lodash';

export const mapKeysToCamelCase = (data: object) => mapKeys(data, (_value, key) => camelCase(key));
